import { History } from "history";

import {
  ADD_CHAPTER,
  ADD_CHAPTER_ERROR,
  ADD_CHAPTER_SUCCESS,
  AddChapterAction,
  AddChapterErrorAction,
  AddChapterSuccessAction,
  DELETE_CHAPTER,
  DELETE_CHAPTER_CONSENT,
  DELETE_CHAPTER_ERROR,
  DELETE_CHAPTER_SUCCESS,
  DeleteChapterAction,
  DeleteChapterConsentAction,
  DeleteChapterErrorAction,
  DeleteChapterSuccessAction,
  GET_CHAPTER,
  GET_CHAPTERS,
  GET_CHAPTERS_ERROR,
  GET_CHAPTERS_SUCCESS,
  GET_CHAPTER_ERROR,
  GET_CHAPTERS_STATS,
  GET_CHAPTERS_STATS_ERROR,
  GET_CHAPTERS_STATS_SUCCESS,
  GET_CHAPTER_SUCCESS,
  GetChapterAction,
  GetChapterErrorAction,
  GetChapterSuccessAction,
  GetChaptersAction,
  GetChaptersErrorAction,
  GetChaptersSuccessAction,
  UPDATE_CHAPTER,
  UPDATE_CHAPTER_ERROR,
  UPDATE_CHAPTER_SUCCESS,
  UpdateChapterAction,
  UpdateChapterErrorAction,
  UpdateChapterSuccessAction,
  GetChaptersStatsAction,
  GetChaptersStatsSuccessAction,
  GetChaptersStatsErrorAction,
  GetChaptersSkillsStatsAction,
  GetChaptersSkillsStatsSuccessAction,
  GET_CHAPTERS_SKILLS_STATS,
  GET_CHAPTERS_SKILLS_STATS_ERROR,
  GET_CHAPTERS_SKILLS_STATS_SUCCESS,
  GetChaptersSkillsStatsErrorAction,
  GetChaptersFlashCardsStatsAction,
  GetChaptersFlashCardsStatsSuccessAction,
  GetChaptersFlashCardsStatsErrorAction,
  GET_CHAPTERS_FLASH_CARDS_STATS,
  GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS,
  GET_CHAPTERS_FLASH_CARDS_STATS_ERROR,
  ToggleChapterStateConsentAction,
  TOGGLE_CHAPTER_STATE,
  TOGGLE_CHAPTER_STATE_CONSENT,
  TOGGLE_CHAPTER_STATE_ERROR,
  TOGGLE_CHAPTER_STATE_SUCCESS,
  ToggleChapterStateAction,
  ToggleChapterStateErrorAction,
  ToggleChapterStateSuccessAction,
  GET_CHAPTERS_LECTURES_STATS,
  GET_CHAPTERS_LECTURES_STATS_ERROR,
  GET_CHAPTERS_LECTURES_STATS_SUCCESS,
  GetChaptersLecturesStatsAction,
  GetChaptersLecturesStatsErrorAction,
  GetChaptersLecturesStatsSuccessAction,
  GET_CHAPTER_LIST_BY_SUBJECT,
  GET_CHAPTER_LIST_BY_SUBJECT_ERROR,
  GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS,
  GetChapterSelectListBySubjectAction,
  GetChapterSelectListBySubjectErrorAction,
  GetChapterSelectListBySubjectSuccessAction,
  RESET_CHAPTER_LIST_BY_SUBJECT,
  ResetChapterListBySubjectAction,
  GET_ORGANIZING_CHAPTERS,
  GET_ORGANIZING_CHAPTERS_ERROR,
  GET_ORGANIZING_CHAPTERS_SUCCESS,
  GetOrganizingChaptersAction,
  GetOrganizingChaptersErrorAction,
  GetOrganizingChaptersSuccessAction,
} from "./actionTypes";
import {
  CreateChapterRequest,
  ChapterDto,
  PaginateQuery,
  UpdateChapterRequest,
  ChapterStatsDto,
  ChapterSkillsStatsDto,
  ChapterFlashCardsStatsDto,
  ChapterLecturesStatsDto,
  OrganizingChapterDto,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Chapters

export const getChapters = (
  request: PaginateQuery,
  history: History
): GetChaptersAction => {
  return {
    type: GET_CHAPTERS,
    payload: { request, history },
  };
};

export const getChaptersSuccess = (
  response: Paginated<ChapterDto>
): GetChaptersSuccessAction => {
  return {
    type: GET_CHAPTERS_SUCCESS,
    payload: response,
  };
};

export const getChaptersError = (error: any): GetChaptersErrorAction => {
  return {
    type: GET_CHAPTERS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter

export const getChapter = (id: string, history: History): GetChapterAction => {
  return {
    type: GET_CHAPTER,
    payload: { id, history },
  };
};

export const getChapterSuccess = (
  response: ChapterDto
): GetChapterSuccessAction => {
  return {
    type: GET_CHAPTER_SUCCESS,
    payload: response,
  };
};

export const getChapterError = (error: any): GetChapterErrorAction => {
  return {
    type: GET_CHAPTER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter Stats

export const getChaptersStats = (
  subjectId: string,
  history: History
): GetChaptersStatsAction => {
  return {
    type: GET_CHAPTERS_STATS,
    payload: { subjectId, history },
  };
};

export const getChaptersStatsSuccess = (
  response: ChapterStatsDto[]
): GetChaptersStatsSuccessAction => {
  return {
    type: GET_CHAPTERS_STATS_SUCCESS,
    payload: response,
  };
};

export const getChaptersStatsError = (
  error: any
): GetChaptersStatsErrorAction => {
  return {
    type: GET_CHAPTERS_STATS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Chapter

export const addChapter = (
  request: CreateChapterRequest,
  history: History
): AddChapterAction => {
  return {
    type: ADD_CHAPTER,
    payload: { request, history },
  };
};

export const addChapterSuccess = (): AddChapterSuccessAction => {
  return {
    type: ADD_CHAPTER_SUCCESS,
    payload: null,
  };
};

export const addChapterError = (error: any): AddChapterErrorAction => {
  return {
    type: ADD_CHAPTER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Chapter

export const updateChapter = (
  id: string,
  request: UpdateChapterRequest,
  history: History
): UpdateChapterAction => {
  return {
    type: UPDATE_CHAPTER,
    payload: { id, request, history },
  };
};

export const updateChapterSuccess = (): UpdateChapterSuccessAction => {
  return {
    type: UPDATE_CHAPTER_SUCCESS,
    payload: null,
  };
};

export const updateChapterError = (error: any): UpdateChapterErrorAction => {
  return {
    type: UPDATE_CHAPTER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Chapter

export const deleteChapterConsent = (
  id: string
): DeleteChapterConsentAction => {
  return {
    type: DELETE_CHAPTER_CONSENT,
    payload: id,
  };
};

export const deleteChapter = (
  id: string,
  history: History
): DeleteChapterAction => {
  return {
    type: DELETE_CHAPTER,
    payload: { id, history },
  };
};

export const deleteChapterSuccess = (): DeleteChapterSuccessAction => {
  return {
    type: DELETE_CHAPTER_SUCCESS,
    payload: null,
  };
};

export const deleteChapterError = (error: any): DeleteChapterErrorAction => {
  return {
    type: DELETE_CHAPTER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter Skills Stats

export const getChaptersSkillsStats = (
  subjectId: string,
  history: History
): GetChaptersSkillsStatsAction => {
  return {
    type: GET_CHAPTERS_SKILLS_STATS,
    payload: { subjectId, history },
  };
};

export const getChaptersSkillsStatsSuccess = (
  response: ChapterSkillsStatsDto[]
): GetChaptersSkillsStatsSuccessAction => {
  return {
    type: GET_CHAPTERS_SKILLS_STATS_SUCCESS,
    payload: response,
  };
};

export const getChaptersSkillsStatsError = (
  error: any
): GetChaptersSkillsStatsErrorAction => {
  return {
    type: GET_CHAPTERS_SKILLS_STATS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter Flash Card Stats

export const getChaptersFlashCardsStats = (
  subjectId: string,
  history: History
): GetChaptersFlashCardsStatsAction => {
  return {
    type: GET_CHAPTERS_FLASH_CARDS_STATS,
    payload: { subjectId, history },
  };
};

export const getChaptersFlashCardsStatsSuccess = (
  response: ChapterFlashCardsStatsDto[]
): GetChaptersFlashCardsStatsSuccessAction => {
  return {
    type: GET_CHAPTERS_FLASH_CARDS_STATS_SUCCESS,
    payload: response,
  };
};

export const getChaptersFlashCardsStatsError = (
  error: any
): GetChaptersFlashCardsStatsErrorAction => {
  return {
    type: GET_CHAPTERS_FLASH_CARDS_STATS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Chapter State

export const toggleChapterStateConsent = (
  id: string
): ToggleChapterStateConsentAction => {
  return {
    type: TOGGLE_CHAPTER_STATE_CONSENT,
    payload: id,
  };
};

export const toggleChapterState = (
  id: string,
  history: History
): ToggleChapterStateAction => {
  return {
    type: TOGGLE_CHAPTER_STATE,
    payload: { id, history },
  };
};

export const toggleChapterStateSuccess = (
  id: string
): ToggleChapterStateSuccessAction => {
  return {
    type: TOGGLE_CHAPTER_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleChapterStateError = (
  error: any
): ToggleChapterStateErrorAction => {
  return {
    type: TOGGLE_CHAPTER_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter Lectures Stats

export const getChaptersLecturesStats = (
  subjectId: string,
  history: History
): GetChaptersLecturesStatsAction => {
  return {
    type: GET_CHAPTERS_LECTURES_STATS,
    payload: { subjectId, history },
  };
};

export const getChaptersLecturesStatsSuccess = (
  response: ChapterLecturesStatsDto[]
): GetChaptersLecturesStatsSuccessAction => {
  return {
    type: GET_CHAPTERS_LECTURES_STATS_SUCCESS,
    payload: response,
  };
};

export const getChaptersLecturesStatsError = (
  error: any
): GetChaptersLecturesStatsErrorAction => {
  return {
    type: GET_CHAPTERS_LECTURES_STATS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Chapter Select List by Subject

export const getChapterSelectListBySubject = (
  subjectId: string
): GetChapterSelectListBySubjectAction => {
  return {
    type: GET_CHAPTER_LIST_BY_SUBJECT,
    payload: { subjectId },
  };
};

export const getChapterSelectListBySubjectSuccess = (
  response: SelectListDto[]
): GetChapterSelectListBySubjectSuccessAction => {
  return {
    type: GET_CHAPTER_LIST_BY_SUBJECT_SUCCESS,
    payload: response,
  };
};

export const getChapterSelectListBySubjectError = (
  error: any
): GetChapterSelectListBySubjectErrorAction => {
  return {
    type: GET_CHAPTER_LIST_BY_SUBJECT_ERROR,
    payload: error,
  };
};

export const resetChapterSelectListBySubject =
  (): ResetChapterListBySubjectAction => {
    return {
      type: RESET_CHAPTER_LIST_BY_SUBJECT,
      payload: {},
    };
  };

//#endregion

//#region Get Organizing Chapters

export const getOrganizingChapters = (
  subjectId: string,
  query: PaginateQuery,
  history: History
): GetOrganizingChaptersAction => {
  return {
    type: GET_ORGANIZING_CHAPTERS,
    payload: { subjectId, query, history },
  };
};

export const getOrganizingChaptersSuccess = (
  response: Paginated<OrganizingChapterDto>
): GetOrganizingChaptersSuccessAction => {
  return {
    type: GET_ORGANIZING_CHAPTERS_SUCCESS,
    payload: response,
  };
};

export const getOrganizingChaptersError = (
  error: any
): GetOrganizingChaptersErrorAction => {
  return {
    type: GET_ORGANIZING_CHAPTERS_ERROR,
    payload: error,
  };
};

//#endregion
